import React, { useContext, useState } from 'react';
import { IntlProvider } from 'react-intl';
import English from '../languages/us-US.json';
import Italian from '../languages/it-IT.json';
import { useSelector } from 'react-redux';

export const Context = React.createContext();
const local = navigator.language;
let lang;

switch (local) {
    case 'en':
        lang = English;
        break;
    case 'it':
        lang = Italian;
        break;
    default:
        lang = English;
}

export const useWrapper = () => useContext(Context);

const Wrapper = (props) => {
    const [locale, setLocale] = useState(local);
    const [messages, setMessages] = useState(lang);
    const user = useSelector(state => state.auth.user);

    React.useEffect(() => {
        if(user){
            var userLanguage = user.profile.user_language;
            if(userLanguage){
                if(userLanguage == 'it'){
                    setLocale('it');
                    setMessages(Italian);
                }
                else if(userLanguage == 'en'){
                    setLocale('en');
                    setMessages(English);
                }
            }
            else{
                setLocale('en');
                setMessages(English);
            }
        }
        else{
            setLocale('en');
            setMessages(English);
        }
    }, [user]);

    function selectLanguage(newLocale) {
        setLocale(newLocale);
        switch (newLocale) {
            case 'en':
                setMessages(English);
                break;
            case 'it':
                setMessages(Italian);
                break;
            default:
                setMessages(English);
        }
    }

    return (
        <Context.Provider value={{ locale, selectLanguage }}>
            <IntlProvider messages={messages} locale={locale}>
                {props.children}
            </IntlProvider>
        </Context.Provider>
    );
}

export default Wrapper;